import {templates} from 'features/beersManager/typescript';
import {PostTypes} from 'features/postGenerator/constants';
import cloneDeep from 'lodash.clonedeep';
import {PubBeer} from 'typescript/models/PubBeer';

import {renderStandardBeers, renderStandard2Beers} from './renderBeerPages';

interface ICreateBeerPagesArgs {
  pubBeers: PubBeer[];
  postType: keyof typeof PostTypes;
  activeTemplate: templates;
  isPriceChecked: boolean;
}
export function createBeerPages({pubBeers, postType, activeTemplate, isPriceChecked}: ICreateBeerPagesArgs) {
  const pubBeersCopy = cloneDeep(pubBeers).filter((pubBeer) => pubBeer.attributes.on_tap);

  const pagesObject: {
    [key in keyof typeof templates]: () => PubBeer[][];
  } = {
    [templates.Standard]: () => renderStandardBeers({pubBeerList: pubBeersCopy, postType, isPriceChecked}),
    [templates.Standard2]: () => renderStandard2Beers(pubBeersCopy, postType),
  };

  return pagesObject[activeTemplate]();
}
